import { createTypes } from '../../utils/helpers';

const HOLIDAYS: any = createTypes('HOLIDAYS');

export { HOLIDAYS };
